import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { Grid, Typography } from './../../../themes/default';
import { Buttons } from './../../../components/includes/container';
import { Btn } from './../../../components/includes/ui';
import { InputTextField } from './../../../components/includes/ui/input';
import { LeadService } from './../../../services';

import VALIDATION from './../../../config/validation';

const validate = values => {

  const errors = {};

  if (!values.street) {
    errors.street = VALIDATION.required;
  }

  if (!values.street_number) {
    errors.street_number = VALIDATION.required;
  }

  return errors

};

class AddressFind extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      sending: false
    };
  }

  /*
  ** @Service
  ** @Description: Find
  */

  randomInteger = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  makeid = (length) => {
     var result           = '';
     var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
     var charactersLength = characters.length;
     for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
     }
     return result;
  }

  _Generate = (values) => {

    const toSend = {
    	"gaTrackId": "UA-139163807-2",
    	"gaClientId": "1769391469.1568983711",
    	"product": "5d7298a245785628316121fa",
    	"step": 4,
    	"validation": true,
    	"apartment_size": 2,
    	"first_name": "German",
    	"document_number": this.randomInteger(20000000, 90000000),
    	"email": `${this.makeid(5)}@hseguros.com.ar`,
    	"mobile_code": "11",
    	"mobile": this.randomInteger(1500000000, 1599999999),
    	"terms": true,
    	"segment": "sale",
    	"country_of_born": "ARGENTINA",
    	"nationality": "ARGENTINA",
    	"gender": "Masculino",
    	"administrative_area": "Buenos Aires",
    	"birthdate": "15/07/2002",
    	"last_name": "Glock",
    	"street": values.street,
    	"street_number": values.street_number,
    	"locality": "GERLI",
    	"geocode": "-34.6960915,-58.3674726",
    	"province": "PROVINCIA DE BUENOS AIRES",
    	"zip": "1642",
    	"id": "5f0f571c749e007a1a11c4f6"
    }

    LeadService.generate(toSend).then((response) => {

        console.log(response);

    }).catch((error) => {

      console.log(error);

    });

  }

  /*
  ** @Event
  ** @Description: Submit form
  */
  handleSubmitForm = (values) => {
    this._Generate(values);
  }

  render() {

    const { sending } = this.state;
    const { handleSubmit, invalid } = this.props;

    return (
      <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>
          <Grid container spacing={24}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Typography>Validar estado de dirección en Rector</Typography>
            </Grid>
            <Grid item lg={8} md={8} sm={8} xs={8}>
              <Field
                  name="street"
                  component={ InputTextField }
                  label="Calle"
                  type="text"
                  required
              />
            </Grid>
            <Grid item lg={4} md={4} sm={4} xs={4}>
              <Field
                  name="street_number"
                  component={ InputTextField }
                  label="Número"
                  type="number"
                  required
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Buttons align="right">
                <Btn aria-label="Buscar" icon="add" color="success" type="submit" disabled={ invalid } loading={ sending }>
                  Buscar
                </Btn>
              </Buttons>
            </Grid>
          </Grid>

      </form>
    )
  }
}

AddressFind = reduxForm({
  form: 'AddressFind',
  validate,
  initialValues: {

  }
})(AddressFind);

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddressFind);
